import React from 'react';
import { useTranslation } from 'next-i18next';
import { ReactComponent as CollapseSvg } from './icons/collapse.svg';
import { ReactComponent as ExpandSvg } from './icons/expand.svg';
import { ToggleItemContainer, ToggleText } from './styled';

export type ToggleItemsProps = {
  isExpanded: boolean;
  onClick: () => void;
  itemsMore: number;
};
const ToggleItems = ({ isExpanded, onClick, itemsMore }: ToggleItemsProps) => {
  const { t } = useTranslation();
  return (
    <ToggleItemContainer
      role="button"
      onClick={onClick}
      onKeyDown={() => {}}
      tabIndex={0}
    >
      {isExpanded ? (
        <CollapseSvg data-testid="collapse-svg" />
      ) : (
        <ExpandSvg data-testid="expand-svg" />
      )}
      <ToggleText data-testid="toggle-text">
        {isExpanded
          ? t('orderShowLess')
          : t('orderShowMore', { count: itemsMore })}
      </ToggleText>
    </ToggleItemContainer>
  );
};

export default ToggleItems;
